const e = {
  NORMAL: "",
  SEARCHED: "d-recipe-feed-item-row__state--searched",
  ERROR: "d-recipe-feed-item-row__state--error"
}, t = "NORMAL", _ = {
  FEED_ROW_STATE_BACKGROUND_COLOR: e,
  DEFAULT_FEED_ROW_STATE: t
};
export {
  t as DEFAULT_FEED_ROW_STATE,
  e as FEED_ROW_STATE_BACKGROUND_COLOR,
  _ as default
};
//# sourceMappingURL=feed-item-row-constants.js.map
